import { render, staticRenderFns } from "./MailingEdit.vue?vue&type=template&id=12489a17&scoped=true&"
import script from "./MailingEdit.vue?vue&type=script&lang=js&"
export * from "./MailingEdit.vue?vue&type=script&lang=js&"
import style0 from "./MailingEdit.vue?vue&type=style&index=0&id=12489a17&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12489a17",
  null
  
)

export default component.exports